import request from '@utils/request'
import configRequest from '@src/config/request'
import { setLocalStorage } from '@utils/localStorage'

export const state = {
  currentMerchant: null,
  currentPrepaidList: null,
  currentUnpaidContiner: {},
}

export const getters = {
  isSiteEnabled(state) {
    return !!state.currentMerchant.cosmeticSetting.isEnabled
  },
  isMemberLevelEnabled(state) {
    return !!state.currentMerchant.components.includes('memberlevel')
  },
  hasDepositModule(state) {
    return !!state.currentMerchant.components.includes('deposit')
  },
  isHasReservationInCart(state) {
    return !!state.currentUnpaidContiner[0] && !!state.currentUnpaidContiner[0]?.orders?.items[0]
  },
}

export const mutations = {
  SET_STATE(state, newValue) {
    state = Object.assign(state, newValue)
  },
  SET_CURRENT_PREPAID_LIST(state, newValue) {
    state.currentPrepaidList = newValue
  },
  SET_CURRENT_UNPAID_CONTAINER(state, newValue) {
    state.currentUnpaidContiner = newValue
    setLocalStorage('currentUnpaidContiner', newValue)
  },
}

export const actions = {
  /**
   * 初始化
   * @param commit
   * @param state
   * @param dispatch
   * @returns {Promise<void>}
   */
  async init({ commit, state, dispatch }) {
    const initState = async () => {
      const isMockApi = this._vm.$apiPath.indexOf('mock') !== -1
      const isDevelopment = process.env.NODE_ENV === 'development'

      /* const formatMerchant = () => {
        const merchantJson = window.globalData.merchant;

        const merchant = (merchantJson || '')
          .replace(/&quot;/g, '"')
          .replace(/(?:\r\n|\r|\n)/g, `\\n`);

        return JSON.parse(merchant);
      }; */
      console.log('init')
      const { items: currentMerchant } =
        !isMockApi && isDevelopment
          ? await dispatch('fetchMerchant')
          : {
              // items: typeof window.globalData.merchant === 'string' ? formatMerchant() : window.globalData.merchant
              items: window.globalData.merchant,
            }

      const stateData = {
        currentMerchant,
      }

      // window.globalData.formatMerchant = stateData.currentMerchant;

      commit('SET_STATE', stateData)
    }

    await initState()
  },

  fetchMerchant({ commit }) {
    return request.get(`/merchant/`, {
      ...configRequest,
      name: 'fetchMerchant',
    })
  },

  /**
   * 取得商家預約列表
   * @param commit
   * @param date
   * @param storeAlias
   * @param sizeAlias
   * @param petId
   * @param prepaidOrderUuid
   * @param limit
   * @param page
   * @param servicePriceGroupId
   * @param types
   * @param scheduleItemId
   * @returns {*}
   */
  fetchReservationList({ commit }, { date, storeAlias, sizeAlias, petId, prepaidOrderUuid, limit = 9, page = 1, order_by = '', servicePriceGroupId, types, scheduleItemId } = {}) {
    return request.post(
      `/merchant/booking/search`,
      {
        date,
        storeAlias,
        sizeAlias,
        petId,
        prepaidOrderUuid,
        limit,
        page,
        order_by,
        servicePriceGroupId,
        types,
        scheduleItemId,
      },
      {
        ...configRequest,
        name: 'fetchReservationList',
        // endLoadingDelay: 2100,
      }
    )
  },

  /**
   * 取得商家預約項目
   * @param commit
   * @param reservationAlias
   * @param date
   * @param prepaidOrderUuid
   * @param types
   * @returns {*}
   */
  fetchReservationItem({ commit }, { reservationAlias, date, prepaidOrderUuid = undefined, scheduleItemId = undefined, types } = {}) {
    return request.post(
      `/merchant/booking/${reservationAlias}`,
      {
        date,
        prepaidOrderUuid,
        scheduleItemId,
        types,
      },
      {
        ...configRequest,
        name: 'fetchReservationItem',
      }
    )
  },

  /**
   * 取得商家預約價目表
   * @param commit
   * @param storeAlias
   * @param categoryAlias
   * @param types
   * @returns {*}
   */
  fetchReservationPrice({ commit }, { storeAlias, categoryAlias, types } = {}) {
    return request.post(
      `/merchant/booking/price`,
      {
        storeAlias,
        categoryAlias,
        types,
      },
      {
        ...configRequest,
        name: 'fetchReservationPrice',
      }
    )
  },
  /**
   * 取得商家行事曆
   * @param commit
   * @param startDate
   * @param endDate
   * @param priceAlias
   * @param storeAlias
   * @param scheduleItemIdm
   * @param prepaidOrderUuid
   * @param sizeAlias
   * @param servicePriceGroupId
   * @param types
   * @returns {*}
   */
  fetchReservationCalendar(
    { commit },
    { startDate, endDate, priceAlias = undefined, scheduleItemId = undefined, prepaidOrderUuid = undefined, storeAlias = undefined, sizeAlias = undefined, servicePriceGroupId, types } = {}
  ) {
    return request.post(
      `/merchant/booking/price/calendar`,
      {
        startDate,
        endDate,
        priceAlias,
        scheduleItemId,
        prepaidOrderUuid,
        storeAlias,
        sizeAlias,
        servicePriceGroupId,
        types,
      },
      {
        ...configRequest,
        name: 'fetchReservationCalendar',
      }
    )
  },

  /**
   * 取得商家包套方案列表
   * @param commit
   * @param state
   * @param storesAlias
   * @param petCategoriesAlias
   * @param limit
   * @param page
   * @param useCached
   * @returns {{items: (*|null)}|*}
   */
  fetchPrepaidList({ commit, state }, { storesAlias = [], petCategoriesAlias = [], limit = 8, page = 1, useCached = false } = {}) {
    const cached = state.currentPrepaidList
    const hasCached = !!cached

    return hasCached && useCached
      ? {
          items: cached,
        }
      : request
          .post(
            `/merchant/prepaid/search`,
            {
              storesAlias,
              petCategoriesAlias,
              limit,
              page,
            },
            {
              ...configRequest,
              name: 'fetchPrepaidList',
            }
          )
          .then((response) => {
            commit('SET_CURRENT_PREPAID_LIST', response.items)

            return response
          })
  },

  /**
   * 取得商家包套方案項目
   * @param commit
   * @param prepaidAlias
   * @returns {*}
   */
  fetchPrepaidItem({ commit }, { prepaidAlias } = {}) {
    return request.get(`/merchant/prepaid/${prepaidAlias}`, {
      ...configRequest,
      name: 'fetchPrepaidItem',
    })
  },
  /**
   * 取得商家包套方案項目
   */
  cancelPrepaidOrder({ commit }, { orderId = '' }) {
    return request.post(`/merchant/member/order/${orderId}/cancel`)
  },
  /**
   * 取得商家等級項目
   * @param commit
   * @returns {*}
   */
  fetchMemberLevel({ commit }) {
    return request
      .get(`/merchant/member/levels`, {
        ...configRequest,
        name: 'fetchMemberLevel',
      })
      .then((response) => {
        return response.items
      })
  },

  /**
   * 取得容器項目
   * @param commit
   * @param types
   * @param is_temp
   * @param paginate
   * @param page
   * @param limit
   * @param paymentStatus
   * @returns {*}
   */
  fetchContainerList(
    { commit },
    {
      types,
      // eslint-disable-next-line camelcase
      is_temp,
      paginate,
      page,
      limit,
      paymentStatus,
    }
  ) {
    return request
      .post(
        '/merchant/member/order/container/search',
        {
          types,
          is_temp,
          paginate,
          page,
          limit,
          paymentStatus,
        },
        {
          ...configRequest,
          name: 'fetchContainerList',
        }
      )
      .then((response) => {
        // eslint-disable-next-line camelcase
        if (is_temp === 1) {
          const res = response.items
          commit('SET_CURRENT_UNPAID_CONTAINER', res || [])
        }
        return response
      })
  },
}
